import { SelectedSponsor } from '../../../../../models/components/dictionaries/sponsor/Sponsor';

export const areAllCheckboxesEmpty = (selectedSponsors: any) =>
  selectedSponsors.every((el: SelectedSponsor) => el.isSelected === false);

export const setDefaultStateCheckbox = (value: boolean, source: SelectedSponsor[]) =>
  source.map((curr: SelectedSponsor) => {
    curr.isSelected = value;
    return curr;
  }, {});
